import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/** @deprecated We are phasing out `redux` */
export interface ToastNotification {
  id: string;
  message: string;
  severity: "error" | "info" | "success" | "warning";
}

/** @deprecated We are phasing out `redux` */
export interface NotificationsState {
  toasts: ToastNotification[];
}

/** @deprecated We are phasing out `redux` */
export const initialState: NotificationsState = {
  toasts: [],
};

/** @deprecated We are phasing out `redux` */
const slice = createSlice({
  initialState,
  name: "notifications",
  reducers: {
    cancelToastNotification: (state: NotificationsState, action: PayloadAction<Pick<ToastNotification, "id">>) => {
      state.toasts = state.toasts.filter(({ id }) => id !== action.payload.id);
    },
    errorToast: (state: NotificationsState, action: PayloadAction<Pick<ToastNotification, "message">>) => {
      state.toasts.push({ id: `${Date.now()}`, message: action.payload.message, severity: "error" });
    },
    infoToast: (state: NotificationsState, action: PayloadAction<Pick<ToastNotification, "message">>) => {
      state.toasts.push({ id: `${Date.now()}`, message: action.payload.message, severity: "info" });
    },
    successToast: (state: NotificationsState, action: PayloadAction<Pick<ToastNotification, "message">>) => {
      state.toasts.push({ id: `${Date.now()}`, message: action.payload.message, severity: "success" });
    },
    warningToast: (state: NotificationsState, action: PayloadAction<Pick<ToastNotification, "message">>) => {
      state.toasts.push({ id: `${Date.now()}`, message: action.payload.message, severity: "warning" });
    },
  },
});

/** @deprecated We are phasing out `redux` */
export const { cancelToastNotification, errorToast, infoToast, successToast, warningToast } = slice.actions;

/** @deprecated We are phasing out `redux` */
export default slice.reducer;
